import { useState } from 'react';
import { Button, Card, Form, Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { post } from '../api';

export default function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const rsp = await post('/admin/login', { ...values });
      if (rsp.code) {
        message.error(rsp.msg || '登录失败');
        return;
      }
      localStorage.setItem('user', JSON.stringify(rsp.data.user));
      localStorage.setItem('token', rsp.data.token);
      navigate('/', { replace: true });
    } catch (e) {
      message.error('网络异常，请稍后再试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Card className="login-card" title="mall admin">
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="loginName" label="用户名" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input placeholder="用户名 / 手机号 / 邮箱" autoComplete="username" />
          </Form.Item>
          <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password placeholder="密码" autoComplete="current-password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
